import script from "./control-dimension.vue?vue&type=script&setup=true&lang=ts"
export * from "./control-dimension.vue?vue&type=script&setup=true&lang=ts"

import "./control-dimension.vue?vue&type=style&index=0&id=fbe3bea2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbe3bea2"]])

export default __exports__